import { makeStyles } from '@material-ui/core'

export default makeStyles((theme) => ({
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(240px, 1fr))',
    gap: theme.spacing(2),
    paddingTop: theme.spacing(1)
  },
  // The credentials block reads as one decision — replace them or leave them —
  // so it is boxed rather than mixed into the field grid above.
  credentials: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.action.hover
  },
  hint: {
    display: 'block',
    paddingTop: theme.spacing(1)
  },
  submit: {
    marginTop: theme.spacing(2)
  }
}))
